import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Title } from '../../components/ui';
import Layout from '../../components/Layout';
import ListView from '../../components/ui/ListView';
import { useSelector } from 'react-redux';
import { navigateToLogin } from '../../utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 90vh;
  padding: 20px;
  position: relative;
`;

const BannerTitle = styled(Title)`
  color: black;
  margin-bottom: 30px;
`;

const CategoryCard = styled.div`
  width: 180px;
  height: 180px;
  background: #f8f9fa;
  border-radius: 15px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease,
    background-color 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 1024px) {
    width: 200px;
    height: 200px;
  }

  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }

  @media (max-width: 480px) {
    width: 140px;
    height: 140px;
  }
`;

const CardTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  text-align: center;
  padding: 0 8px;

  @media (max-width: 1024px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const ShopByPage = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.userInfo);

  // Shop by categories data
  const shopByCategories = [
    {
      id: 'brand',
      title: 'Shop By Brand',
      icon: '🏷️',
      link: '/brands',
    },
  ];

  const handleCategoryClick = (item) => {
    if (userInfo.userId != 0) {
      navigate(item.link);
    } else {
      navigateToLogin(navigate, item.link);
    }
  };

  const renderCategoryItem = ({ item }) => {
    return (
      <div style={{ textAlign: 'center' }}>
        <CategoryCard onClick={() => handleCategoryClick(item)}>
          {item.id === 'brand' && <CardTitle>{item.title}</CardTitle>}
        </CategoryCard>
      </div>
    );
  };

  return (
    <Layout>
      <Container>
        <BannerTitle>Shop By</BannerTitle>

        <ListView
          data={shopByCategories}
          renderItem={renderCategoryItem}
          numColumns={(width) =>
            width <= 480 ? 2 : width <= 768 ? 3 : width <= 1024 ? 4 : 5
          }
          rowGap={'20px'}
          columnGap={'20px'}
        />
      </Container>
    </Layout>
  );
};

export default ShopByPage;
